// extracted by mini-css-extract-plugin
export default {"overflowColumn":"_yi_Xpw"};